<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="29" height="29" stroke="currentColor" stroke-dasharray="5 3"/>
<path d="M16 10.0077V21.9923" stroke="currentColor" stroke-width="2"/>
<path d="M21.9927 16L10.008 16" stroke="currentColor" stroke-width="2"/>
</svg>
